<div class="flex flex-col mb-4">
  <p class="font-bold mb-1">Filtrowanie</p>
  <div class="flex gap-2 flex-wrap">
    @for (statusButton of statusButtons; track statusButton.value) {
      <p-button
        (click)="selectStatus(statusButton.value)"
        [icon]="isStatusActive(statusButton.value) ? 'pi pi-times' : ''"
        [label]="statusButton.label"
        [styleClass]="
          'customInfoButton bolder' +
          (!isStatusActive(statusButton.value) ? ' outlined silver' : '')
        "
        iconPos="right"
        size="small"
      />
    }
  </div>
</div>

<div class="wide">
  <app-table-scroll-wrapper [loading]="isDataLoading()">
    <p-table
      #table
      (onSort)="onPrimeSortChange($event)"
      [lazy]="true"
      [loading]="isDataLoading()"
      [rows]="tablePage()?.size || 10"
      [scrollable]="true"
      scrollHeight="flex"
      [tableStyle]="{ 'min-width': '75rem' }"
      [totalRecords]="tablePage()?.totalElements || 0"
      [value]="rows()"
      dataKey="documentId"
      class="customPrimeTable"
    >
      <ng-template #header>
        <tr class="filters-row">
          <th pSortableColumn="nazwaWniosku" class="w-48 min-w-48 max-w-48">
            <div class="flex items-center gap-2">
              Nazwa wniosku
              <p-sortIcon field="nazwaWniosku" />
            </div>
          </th>
          <th pSortableColumn="status" class="w-42 min-w-42 max-w-42">
            <div class="flex items-center gap-2">
              Status
              <p-sortIcon field="status" />
            </div>
          </th>
          <th pSortableColumn="archiwalny" class="w-45 min-w-45 max-w-45">
            <div class="flex items-center gap-2">
              Archiwalny
              <p-sortIcon field="archiwalny" />
            </div>
          </th>
          <th pSortableColumn="adresatLubNadawca" class="w-45 min-w-45 max-w-45">
            <div class="flex items-center gap-2">
              Adresat/Nadawca
              <p-sortIcon field="adresatLubNadawca" />
            </div>
          </th>
          <th pSortableColumn="numerDokumentu" class="w-48 min-w-48 max-w-48">
            <div class="flex items-center gap-2">
              Numer dokumentu
              <p-sortIcon field="numerDokumentu" />
            </div>
          </th>
          <th pSortableColumn="dataUtworzenia" class="w-55 min-w-55 max-w-55">
            <div class="flex items-center gap-2">
              Data wniosku roboczego
              <p-sortIcon field="dataUtworzenia" />
            </div>
          </th>
          <th pSortableColumn="dataWyslaniaLubNadania" class="w-55 min-w-55 max-w-55">
            <div class="flex items-center gap-2">
              Data wysłania/nadania
              <p-sortIcon field="dataWyslaniaLubNadania" />
            </div>
          </th>
          <th pSortableColumn="dataPoswiadczenia" class="w-55 min-w-55 max-w-55">
            <div class="flex items-center gap-2">
              Data poświadczenia
              <p-sortIcon field="dataPoswiadczenia" />
            </div>
          </th>
        </tr>
        <tr>
          <td class="table-filter-cell w-48 min-w-48 max-w-48">
            <input
              (change)="onPrimeFilterChange($event.target, 'nazwaWniosku')"
              [(ngModel)]="tableFilters.nazwaWniosku"
              aria-label="Filtruj po nazwie wniosku"
              class="w-full"
              pInputText
            />
          </td>
          <td class="table-filter-cell w-42 min-w-42 max-w-42">
            <p-select
              (onChange)="onStatusFilterChange($event.value)"
              [options]="statusButtons"
              [pTooltip]="getSelectedStatusLabel()"
              [showClear]="true"
              [(ngModel)]="tableFilters.status"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz status"
              appendTo="body"
              class="w-full"
              ariaLabel="Filtruj po statusie"
              tooltipPosition="top"
            />
          </td>
          <td class="table-filter-cell w-45 min-w-45 max-w-45">
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'archiwalny')"
              [options]="archiwalnyOptions"
              [pTooltip]="getSelectedArchiwalnyLabel()"
              [showClear]="true"
              [(ngModel)]="tableFilters.archiwalny"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz wartość"
              appendTo="body"
              class="w-full"
              ariaLabel="Filtruj po archiwalności"
              tooltipPosition="top"
            />
          </td>
          <td class="table-filter-cell w-45 min-w-45 max-w-45">
            <input
              (change)="onPrimeFilterChange($event.target, 'adresatLubNadawca')"
              [(ngModel)]="tableFilters.adresatLubNadawca"
              aria-label="Filtruj po adresacie lub nadawcy"
              class="w-full"
              pInputText
            />
          </td>
          <td class="table-filter-cell w-48 min-w-48 max-w-48">
            <input
              (change)="onPrimeFilterChange($event.target, 'numerDokumentu')"
              [(ngModel)]="tableFilters.numerDokumentu"
              aria-label="Filtruj po numerze dokumentu"
              class="w-full"
              pInputText
            />
          </td>
          <td class="table-filter-cell w-55 min-w-55 max-w-55">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'dataUtworzenia')"
              (onSelect)="onPrimeFilterChange($event, 'dataUtworzenia')"
              [readonlyInput]="true"
              [showClear]="true"
              [inputStyleClass]="'w-full'"
              [(ngModel)]="tableFilters.dataUtworzenia"
              appendTo="body"
              class="w-full customDatePicker table-date-filter"
              dateFormat="dd-mm-yy"
              ariaLabel="Filtruj po dacie utworzenia roboczego"
            />
          </td>
          <td class="table-filter-cell w-55 min-w-55 max-w-55">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'dataWyslaniaLubNadania')"
              (onSelect)="onPrimeFilterChange($event, 'dataWyslaniaLubNadania')"
              [readonlyInput]="true"
              [showClear]="true"
              [inputStyleClass]="'w-full'"
              [(ngModel)]="tableFilters.dataWyslaniaLubNadania"
              appendTo="body"
              class="w-full customDatePicker table-date-filter"
              dateFormat="dd-mm-yy"
              ariaLabel="Filtruj po dacie wysłania lub nadania"
            />
          </td>
          <td class="table-filter-cell w-55 min-w-55 max-w-55">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
              (onSelect)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
              [readonlyInput]="true"
              [showClear]="true"
              [inputStyleClass]="'w-full'"
              [(ngModel)]="tableFilters.dataPoswiadczenia"
              appendTo="body"
              class="w-full customDatePicker table-date-filter"
              dateFormat="dd-mm-yy"
              ariaLabel="Filtruj po dacie poświadczenia"
            />
          </td>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td class="w-48 min-w-48 max-w-48">
            {{
              row.status === 'ODEBRANY' || row.status === 'OCZEKUJACY_NA_ODBIOR'
                ? ''
                : row.nazwaWniosku
            }}
          </td>
          <td class="w-42 min-w-42 max-w-42">
            <span
              [ngClass]="
                row.status | adminPanelUserCorrespondenceStatusBadgeClass
              "
            >
              {{
                row.status | constLabelReader: AdminPanelCorrespondenceStatus
              }}
            </span>
          </td>
          <td class="w-45 min-w-45 max-w-45">
            <input
              type="checkbox"
              class="archival-checkbox"
              [checked]="row.archiwalny"
              disabled
            />
          </td>
          <td class="w-45 min-w-45 max-w-45">{{ row.adresatLubNadawca }}</td>
          <td class="document-number w-48 min-w-48 max-w-48">
            {{ row.numerDokumentu }}
          </td>
          <td class="w-55 min-w-55 max-w-55">
            {{ row.dataUtworzenia | date: 'yyyy-MM-dd HH:mm:ss' }}
          </td>
          <td class="w-55 min-w-55 max-w-55">
            {{ row.dataWyslaniaLubNadania | date: 'yyyy-MM-dd HH:mm:ss' }}
          </td>
          <td class="w-55 min-w-55 max-w-55">{{ row.dataPoswiadczenia | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="7">Brak danych</td>
        </tr>
      </ng-template>
    </p-table>
  </app-table-scroll-wrapper>

  <div class="table-footer">
    <div class="table-pagination">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
      />
      <div class="table-meta">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>
  </div>
</div>

<div class="narrow">
  <p-card class="mb-4">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="nazwaWnioskuMobileLabel">
          Nazwa wniosku
        </span>
        <input
          aria-labelledby="nazwaWnioskuMobileLabel"
          (input)="onFilterChangeMobile($event.target, 'nazwaWniosku')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.nazwaWniosku"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="statusMobileLabel">Status</span>
        <p-select
          ariaLabelledBy="statusMobileLabel"
          (onChange)="onStatusFilterChange($event.value)"
          [options]="statusButtons"
          [pTooltip]="getSelectedStatusLabel()"
          [showClear]="true"
          [(ngModel)]="tableFilters.status"
          optionLabel="label"
          optionValue="value"
          placeholder="Wybierz status"
          appendTo="body"
          class="w-full"
          tooltipPosition="top"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="archiwalnyMobileLabel">Archiwalny</span>
        <p-select
          ariaLabelledBy="archiwalnyMobileLabel"
          (onChange)="onPrimeFilterChange($event.value, 'archiwalny')"
          [options]="archiwalnyOptions"
          [pTooltip]="getSelectedArchiwalnyLabel()"
          [showClear]="true"
          [(ngModel)]="tableFilters.archiwalny"
          optionLabel="label"
          optionValue="value"
          placeholder="Wybierz wartosc"
          appendTo="body"
          class="w-full"
          tooltipPosition="top"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="adresatLubNadawcaMobileLabel">
          Adresat/Nadawca
        </span>
        <input
          aria-labelledby="adresatLubNadawcaMobileLabel"
          (input)="onFilterChangeMobile($event.target, 'adresatLubNadawca')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.adresatLubNadawca"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="numerDokumentuMobileLabel">
          Numer dokumentu
        </span>
        <input
          aria-labelledby="numerDokumentuMobileLabel"
          (input)="onFilterChangeMobile($event.target, 'numerDokumentu')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.numerDokumentu"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="dataUtworzeniaMobileLabel">
          Data wniosku roboczego
        </span>
        <p-date-picker
          ariaLabelledBy="dataUtworzeniaMobileLabel"
          (onClear)="onPrimeFilterChange($event, 'dataUtworzenia')"
          (onSelect)="onPrimeFilterChange($event, 'dataUtworzenia')"
          [readonlyInput]="true"
          [showClear]="true"
          [(ngModel)]="tableFilters.dataUtworzenia"
          appendTo="body"
          class="w-full"
          dateFormat="dd-mm-yy"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="dataWyslaniaLubNadaniaMobileLabel">
          Data wyslania/nadania
        </span>
        <p-date-picker
          ariaLabelledBy="dataWyslaniaLubNadaniaMobileLabel"
          (onClear)="onPrimeFilterChange($event, 'dataWyslaniaLubNadania')"
          (onSelect)="onPrimeFilterChange($event, 'dataWyslaniaLubNadania')"
          [readonlyInput]="true"
          [showClear]="true"
          [(ngModel)]="tableFilters.dataWyslaniaLubNadania"
          appendTo="body"
          class="w-full"
          dateFormat="dd-mm-yy"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="dataPoswiadczeniaMobileLabel">
          Data poswiadczenia
        </span>
        <p-date-picker
          ariaLabelledBy="dataPoswiadczeniaMobileLabel"
          (onClear)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
          (onSelect)="onPrimeFilterChange($event, 'dataPoswiadczenia')"
          [readonlyInput]="true"
          [showClear]="true"
          [(ngModel)]="tableFilters.dataPoswiadczenia"
          appendTo="body"
          class="w-full"
          dateFormat="dd-mm-yy"
        />
      </div>
      <div class="flex justify-end">
        <p-button
          type="button"
          label="Wyczysc filtry"
          styleClass="customInfoButton outlined"
          (click)="clearFilters()"
        />
      </div>
    </div>
  </p-card>

  <div class="flex flex-col gap-6">
    @for (row of rows(); track row.documentId) {
      <p-card>
        <div class="flex flex-col gap-2">
          <div>
            <span class="font-bold">Nazwa wniosku</span>
            <div>
              {{
                row.status === 'ODEBRANY' ||
                row.status === 'OCZEKUJACY_NA_ODBIOR'
                  ? ''
                  : row.nazwaWniosku
              }}
            </div>
          </div>
          <div>
            <span class="font-bold">Status</span>
            <div>
              <span
                [ngClass]="
                  row.status | adminPanelUserCorrespondenceStatusBadgeClass
                "
              >
                {{
                  row.status | constLabelReader: AdminPanelCorrespondenceStatus
                }}
              </span>
            </div>
          </div>
          <div>
            <span class="font-bold">Archiwalny</span>
            <div>
              <input
                type="checkbox"
                class="archival-checkbox"
                [checked]="row.archiwalny"
                disabled
              />
            </div>
          </div>
          <div>
            <span class="font-bold">Adresat/Nadawca</span>
            <div>{{ row.adresatLubNadawca }}</div>
          </div>
          <div>
            <span class="font-bold">Numer dokumentu</span>
            <div class="document-number">{{ row.numerDokumentu }}</div>
          </div>
          <div>
            <span class="font-bold">Data wniosku roboczego</span>
            <div>
              {{ row.dataUtworzenia | date: 'yyyy-MM-dd HH:mm:ss' }}
            </div>
          </div>
          <div>
            <span class="font-bold">Data wyslania/nadania</span>
            <div>
              {{ row.dataWyslaniaLubNadania | date: 'yyyy-MM-dd HH:mm:ss' }}
            </div>
          </div>
          <div>
            <span class="font-bold">Data poswiadczenia</span>
            <div>{{ row.dataPoswiadczenia | date: 'yyyy-MM-dd HH:mm:ss' }}</div>
          </div>
        </div>
      </p-card>
    }

    <div class="table-pagination">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
      />
      <div class="table-meta">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>
  </div>
</div>
